import { useUser } from './user'

export const usePermission = () => {
    const user = useUser()
    const hasPermission = (name) => !!user.user_permissions.find(perm => perm == name)
    return { hasPermission }
}